import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LandingComponent} from './pages/landing/landing.component';
import {ApplicationFormComponent} from './pages/application-form/application-form.component';
import {ConfirmationComponent} from './pages/confirmation/confirmation.component';
import { CustomerComponent } from './pages/customer/customer.component';
import { ReviewComponent } from './pages/review/review.component';
import { UploadSuccessComponent } from './pages/upload-success/upload-success.component';
import { AuthGuardService } from './services/auth-guard.service';

const routes: Routes = [
  {path: '', redirectTo: '/welcome', pathMatch: 'full'},
  {path: 'welcome', component: LandingComponent},
  {path: 'customer', component:CustomerComponent},
  //{path: 'application/:division', component: ApplicationFormComponent},
  {path: 'application', component: ApplicationFormComponent, canActivate:[AuthGuardService]},
  {path: 'confirmation/:applicationId', component: ConfirmationComponent},
  {path: 'review', component: ReviewComponent},
  {path: 'success', component: UploadSuccessComponent}
];


@NgModule({
  imports: [RouterModule.forRoot(routes,{scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
